import React, { useState } from "react";

type Props = {
  dataLength?: number,
  page_size: number;
  page_number: number;
  setpage_number: (value: number) => void;
}

export default function Pagination({dataLength, page_size, page_number, setpage_number, ...args}: Props) {
  const [pagination_page_number, setpagination_page_number] = useState<number>(page_number);
  const total_data: number = dataLength ? dataLength : 0;
  const total_pages: number = Math.ceil(total_data / page_size);
  const paginations = [];
  for (let i = 1; i <= total_pages; i++) {
    paginations.push(
      <button 
        onClick={() => {setpage_number(i); setpagination_page_number(i);}}
        className={`page ${pagination_page_number === i ? "active" : ""} btn-link-custom`}>
        {i}
      </button>
    );
  }

  return total_data === 0 ? (
    <div className="text-center" data-testid="paginationcomponent">
      <div className="pagination pt-3">
        <button className={`btn`} disabled>
          <span> &#60;</span>
        </button>
        <div className="pages">
          <button type="button" className={`page ${page_number === 1 ? "active" : ""}`}>
            {1}
          </button>
        </div>
        <button
         className={`btn`}
         disabled>
          <span> &#62;</span>
        </button>
      </div>
    </div>
  ) : (
    <div className="text-center" data-testid="paginationcomponent">
      <div className="pagination pt-3 ">
        <button
          className={`btn ${pagination_page_number > 1 ? "active" : ""}`}
          onClick={() =>
            pagination_page_number > 1
              ? (setpage_number(pagination_page_number - 1),
                setpagination_page_number(pagination_page_number - 1))
              : ""
          }
        >
          <span> &#60;</span>
        </button>
        {/* <div className="pages">{paginations}</div> */}
        <div className="pages">
          <button
            onClick={() => {setpage_number(1); setpagination_page_number(1)}}
            type="button"
            className={`page ${page_number === 1 ? "active" : ""}`}
          >
            {1}
          </button>
          {page_number > 3 && <div className="page">...</div>}
          {page_number === total_pages && total_pages > 3 && (
            <button
              onClick={() => {setpage_number(page_number - 2); setpagination_page_number(page_number - 2);}}
              type="button"
              className="page">
              {page_number - 2}
            </button>
          )}
          {page_number > 2 && (
            <button
              onClick={() => {setpage_number(page_number - 1); setpagination_page_number(page_number - 1);}}
              type="button"
              className="page"
            >
              {page_number - 1}
            </button>
          )}
          {page_number !== 1 && page_number !== total_pages && (
            <button
              onClick={() => {setpage_number(page_number); setpagination_page_number(page_number);}}
              type="button"
              className={`page active`}
            >
              {page_number}
            </button>
          )}
          {page_number < total_pages - 1 && (
            <button
              onClick={() => {setpage_number(page_number + 1); setpagination_page_number(page_number + 1);}}
              type="button"
              className="page"
            >
              {page_number + 1}
            </button>
          )}
          {page_number === 1 && total_pages > 3 && (
            <button
              onClick={() => {setpage_number(page_number + 2); setpagination_page_number(page_number + 2);}}
              type="button"
              className="page"
            >
              {page_number + 2}
            </button>
          )}
          {page_number < total_pages - 2 && <div className="page">...</div>}
          {total_pages !== 1 && <button
            onClick={() => {setpage_number(total_pages); setpagination_page_number(total_pages)}}
            type="button"
            className={`page ${page_number === total_pages ? "active" : ""}`}
          >
            {total_pages}
          </button>}
        </div>
        <button className={`btn ${pagination_page_number < total_pages ? "active" : ""}`}
          onClick={() =>
            pagination_page_number < total_pages ? (setpage_number(pagination_page_number + 1), 
                setpagination_page_number(pagination_page_number + 1))
              : ""
          }>
          <span> &#62;</span>
        </button>
      </div>
    </div>
  );
}

